<a href="#main-content" class="visually-hidden-focusable">Saltar al contenido principal</a>
<header>
	<div class="fixed-top fixed-top-1">
		<div class="container">
			<button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
				aria-controls="offcanvasNavbar" aria-label="Abrir menú de navegación">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="logo">
				<a routerLink="/home" class="navbar-brand">
					<img src="assets/images/logo_ZBE_WEB-01.svg" alt="logo">
					<!-- <p i18n>Zona de Bajas Emisiones</p> -->
				</a>
			</div>
			<div class="locale-selector">
				<i class="bi bi-plus icon-click accesibility" (click)="moreTextSize()"></i>
				<i class="bi bi-dash icon-click accesibility" (click)="lessTextSize()"></i>
				<i class="bi bi-paint-bucket icon-click accesibility" (click)="toggleContrast()"></i>
				<i class="bi bi-translate"></i>
				<select class="form-select" aria-label="Default select example"
					(change)="changeLocale($event)">
					@for (locale of localesList; track locale.code) {
					<option [value]="locale.code" [selected]="selectedLocale==locale.code">{{ locale.label
						}}</option>
					}
				</select>
			</div>
		</div>
	</div>
	<nav class="navbar fixed-top fixed-top-2 navbar-expand-lg">
		<div class="container">
			<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar">

				<div class="offcanvas-header">
					<h1 class="offcanvas-title" id="offcanvasNavbarLabel">
						<div class="logo">
							<a routerLink="/home" class="navbar-brand">
								<img src="assets/images/logo_ZBE_WEB-01.svg" alt="logo">
							</a>
							<!-- <p i18n>Zona de Bajas Emisiones</p> -->
						</div>
					</h1>
					<button type="button" class="btn-close btn-close" data-bs-dismiss="offcanvas"
						aria-label="Close"></button>
				</div>

				<div class="offcanvas-body justify-content-end">

					<div class="auth order-md-2">
						<button type="button" class="btn btn-secondary btn-sin-loguer" (click)="goToLogin()"
							data-bs-dismiss="offcanvas" *ngIf="!authService.isAuthenticated()"><span
								i18n>Área privada</span></button>

						<div class="userMenu dropdown d-none d-lg-flex d-xl-flex" *ngIf="authService.isAuthenticated()">
							<button class="btn btn-secondary dropdown-toggle btn-login" [ngClass]="{'private': authService.isPrivate()}" type="button" data-bs-toggle="dropdown"
							aria-expanded="false">
								<div class="user-name">
									<div>
										<i class="bi bi-person-circle"></i>
										{{authService.getCurrentUser().name}}
									</div>
									<small class="role-name" *ngIf="authService.isPrivate() && getRoleName()">{{getRoleName()}}</small>
								</div>
								<div class="arrow-box">
									<i class="bi bi-caret-down-fill"></i>
								</div>
							</button>
							<ul class="dropdown-menu dropdown-menu-end">
								@if( !authService.isPrivate() && authService.hasApplicant() ){
									<li>
										<a class="dropdown-item" routerLinkActive="active" routerLink="/profile" i18n>Mi Perfil</a>
									</li>
									<li>
										<a class="dropdown-item" routerLinkActive="active" routerLink="/vehicles"i18n>Mis autorizaciones</a>
									</li>
									<li>
										<a class="dropdown-item" routerLinkActive="active" routerLink="/access" i18n>Mis accesos</a>
									</li>
									<li>
										<a class="dropdown-item" routerLinkActive="active" routerLink="/exceptions/new/new/multiple" i18n>Autorizaciones para flotas</a>
									</li>
								}
								@if (authService.isPrivate()) {
									<li>
										<a class="dropdown-item" routerLinkActive="active" routerLink="/requests" i18n>Solicitudes</a>
									</li>
									<li>
										<a class="dropdown-item" routerLinkActive="active" routerLink="/signatures" i18n>Firmas</a>
									</li>
									<li>
										<a class="dropdown-item" routerLinkActive="active"  routerLink="/private-access" i18n>Accesos (presencial)</a>
									</li>
									<li>
										<a class="dropdown-item" routerLinkActive="active"  routerLink="/users" i18n>Autorización (presencial)</a>
									</li>
								}
								@if( authService.isPrivate() && (authService.isLevel2() || authService.isAdmin()) ){
									<li>
										<a class="dropdown-item" routerLinkActive="active"  routerLink="/operators" i18n>Operadores</a>
									</li>
								}
								@if (authService.isPrivate()) {
									<li>
										<a class="dropdown-item" routerLinkActive="active"  routerLink="/contacts" i18n>Consultas</a>
									</li>
								}
								@if( !authService.isPrivate() && authService.hasApplicant() ){
									<li>
										<a class="dropdown-item" routerLinkActive="active"  routerLink="/exceptions/new/new/multiple" i18n>Autorizaciones para flotas</a>
									</li>
								}
								@if(authService.isPrivate() && (authService.isLevel2() || authService.isAdmin())){
									<li>
										<a class="dropdown-item" routerLinkActive="active"  routerLink="/traces" i18n>Informe trazabilidad</a>
									</li>
								}
								<li>
									<a class="dropdown-item" routerLink="#" (click)="logout()" i18n>Cerrar sesión</a>
								</li>
							</ul>
						</div>

						<div class="userMenu userMenu-mobile dropdown d-lg-none d-xl-none" *ngIf="authService.isAuthenticated()">
							<i class="bi bi-person-circle"></i>
							<p class="name">{{authService.getCurrentUser().name}}</p>

							<ul class="list-group list-group-horizontal">
								<li class="list-group-item">
									<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/profile" i18n>Mi perfil</a>
								</li>
								@if(!authService.isPrivate()){

									<li class="list-group-item">
										<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/vehicles"i18n>Mis autorizaciones</a>
									</li>
									<li class="list-group-item">
										<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/access" i18n>Mis vehículos (accesos)</a>
									</li>
									<li class="list-group-item">
										<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/exceptions/new/new/multiple" i18n>Autorizaciones para flotas</a>
									</li>
								}

								@if( authService.isPrivate() ){
									<li class="list-group-item">
										<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/requests" i18n>Solicitudes</a>
									</li>
									<li class="list-group-item">
										<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/private-access" i18n>Accesos</a>
									</li>
									<li class="list-group-item">
										<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/users" i18n>Usuarios</a>
									</li>
									<!-- <li class="list-group-item">
										<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/signatures" i18n>Firmas</a>
									</li> -->
								}
								<li class="list-group-item" *ngIf="authService.isPrivate() && (authService.isLevel2() || authService.isAdmin())">
									<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/operators" i18n>Operadores</a>
								</li>
								<li class="list-group-item" *ngIf="authService.isPrivate()">
									<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/contacts" i18n>Consultas</a>
								</li>
								<li class="list-group-item" *ngIf="authService.isPrivate() && (authService.isLevel2() || authService.isAdmin())">
									<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="/traces" i18n>Informe trazabilidad</a>
								</li>
								<li class="list-group-item">
									<a data-bs-dismiss="offcanvas" aria-current="page" routerLinkActive="active" routerLink="#" (click)="logout()" i18n>Cerrar sesión</a>
								</li>
							</ul>
						</div>

					</div>

					<ul class="navbar-nav justify-content-end flex-grow-1 pe-3 order-md-1" *ngIf="(!authService.isAuthenticated() || !authService.isPrivate()) && actualUrl.indexOf('login-private')==-1">
						<li class="nav-item">
							<a class="nav-link" aria-current="page" routerLinkActive="active" routerLink="/home"
								i18n data-bs-dismiss="offcanvas" i18n>Inicio</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" aria-current="page" routerLinkActive="active" routerLink="/who" i18n
								data-bs-dismiss="offcanvas" i18n>¿Qué es una ZBE?</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" aria-current="page" routerLinkActive="active" routerLink="/zbe"
								i18n data-bs-dismiss="offcanvas" i18n>ZBE actuales</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" aria-current="page" routerLinkActive="active"
								routerLink="/vehicles-check" i18n data-bs-dismiss="offcanvas" i18n>Vehículos afectados</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" aria-current="page" routerLinkActive="active"
								routerLink="/autorizations" i18n data-bs-dismiss="offcanvas"
								i18n>Autorizaciones</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" aria-current="page" routerLinkActive="active" routerLink="/faq" i18n
								data-bs-dismiss="offcanvas" i18n>Preguntas frecuentes</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" aria-current="page" routerLinkActive="active" routerLink="/contact" i18n
								data-bs-dismiss="offcanvas" i18n>Contacto</a>
						</li>
					</ul>

					<div class="accesibility-box d-lg-none d-xl-none">
						<i class="bi bi-plus icon-click accesibility" (click)="moreTextSize()"></i>
						<i class="bi bi-dash icon-click accesibility" (click)="lessTextSize()"></i>
						<i class="bi bi-paint-bucket icon-click accesibility" (click)="toggleContrast()"></i>
					</div>
				</div>
			</div>
		</div>
	</nav>
</header>